import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
const PointsBox = ({ color = '#fff', backgroundColor = '#327861', points }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: 'points-box', style: { backgroundColor, color }, children: [_jsx("span", { className: "points-box-value", children: points > 0 ? '+' + points : points }), _jsx("span", { className: 'points-box-label', children: t('label.points') })] }));
};
export default PointsBox;
